type Site = "pubblica" | "assicura";

interface SiteConfig {
  showSalesforceChatbot: boolean;
  showIndigoChatbot: boolean;
}

const configs: Record<Site, SiteConfig> = {
  pubblica: {
    showSalesforceChatbot: true,
    showIndigoChatbot: true,
  },
  assicura: {
    showSalesforceChatbot: false,
    showIndigoChatbot: false,
  },
};

const site = (process.env.GATSBY_SITE ?? "pubblica") as Site;

export const siteConfig = configs[site];
export const IS_ASSICURA = site === "assicura";
